<script setup lang="ts">
import LoginForm from '@/components/auth/LoginForm.vue'
</script>

<template>
  <div class="login-view">
    <div class="login-bg">
      <div class="login-brand">
        <img class="login-logo" src="/assets/logo_mc.png" alt="Korus" />
        <span class="login-wordmark">korus</span>
      </div>
      <p class="login-tagline">Análisis inteligente de documentos</p>
    </div>
    <div class="login-card-area">
      <LoginForm />
    </div>
  </div>
</template>

<style scoped>
.login-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg);
}

.login-bg {
  background: var(--korus-navy);
  padding: var(--space-xl) var(--space-lg);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-sm);
}

.login-brand {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.login-logo {
  height: 36px;
  width: auto;
}

.login-wordmark {
  font-family: var(--font-body);
  font-size: 22px;
  font-weight: 700;
  color: var(--color-text-inverse);
  letter-spacing: -0.5px;
}

.login-tagline {
  font-family: var(--font-heading);
  font-size: 13px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 0.2px;
}

.login-card-area {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: var(--space-lg) var(--space-md);
  margin-top: -12px;
}
</style>
